/**
 * Coaching Session Bookings Hooks
 * React Query hooks for fetching session bookings
 */

import { useQuery } from "@tanstack/react-query"
import * as coachingService from "../services/coaching.service"

export type BookingTab = "upcoming" | "completed"

/**
 * Get bookings for a coaching session
 * Only available for the session owner
 */
export function useCoachingSessionBookings(
  sessionId: string,
  options?: {
    search?: string
    tab?: BookingTab
    enabled?: boolean
  },
) {
  return useQuery({
    queryKey: ["coaching-session-bookings", sessionId, options?.search, options?.tab],
    queryFn: () =>
      coachingService.getCoachingSessionBookings(sessionId, {
        search: options?.search,
        tab: options?.tab,
      }),
    enabled: options?.enabled ?? !!sessionId,
    staleTime: 1000 * 60 * 2, // 2 minutes
  })
}
